import { TextField, Typography } from '@material-ui/core';
import { Autocomplete as MUIAutoComplete, Stack } from '@mui/material';
import React from 'react';

export const AutoComplete = ({
  list,
  label,
  onChange,
  optionLabelField,
  name = '',
  id = '',
  inputLabel = '',
  defaultValue = null,
  value,
}









) => {
  return (
    React.createElement(Stack, { flexDirection: "column", gap: 1, minWidth: "300px",}
      , React.createElement(Typography, { variant: "body1", style: { fontWeight: 'bold' },}
        , label
      )
      , React.createElement(MUIAutoComplete, {
        defaultValue: defaultValue,
        value: value,
        options: list,
        fullWidth: true,
        getOptionLabel: option => {
          const text = optionLabelField.map(item => option[item]);
          return text.join(' ');
        },
        renderInput: params => (
          React.createElement(TextField, {
            ...params,
            label: inputLabel,
            variant: "outlined",
            name: name,
            id: id,}
          )
        ),
        onChange: (_, item) => onChange(item),
        filterOptions: (options, params) => {
          return options.filter(
            option =>
              optionLabelField
                .map(optionItem => option[optionItem])
                .join(' ')
                .toLowerCase()
                .indexOf(params.inputValue.toLowerCase()) !== -1,
          );
        },}
      )
    )
  );
};
